<sabis-ngx-dialog [scTitle]="title">

  <div modal-body class="sc-inputs-dialog">
    <!-- header message -->
    <p *ngFor="let message of messages" style="word-break: break-word">
      {{ message }}
    </p>

    <!-- parts -->
    <div *ngFor="let part of parts">
      <!-- text -->
      <sabis-ngx-input *ngIf="part.type === 'text'"
                       [scLabel]="part.label"
                       type="text"
                       [ngModel]="part.value"
                       (ngModelChange)="onModelChange($event, part)"
                       [required]="part.required ?? false" />

      <!-- text-area -->
      <sabis-ngx-textarea *ngIf="part.type === 'multiline'"
                          [scLabel]="part.label"
                          [scCols]="100"
                          [scRows]="10"
                          [ngModel]="part.value"
                          (ngModelChange)="onModelChange($event, part)"
                          [required]="part.required ?? false" />

      <!-- date -->
      <sabis-ngx-datepicker *ngIf="part.type === 'date'"
                            [scLabel]="part.label"
                            [ngModel]="part.value"
                            [min]="part.minDate"
                            [max]="part.maxDate"
                            (ngModelChange)="onModelChange($event, part)"
                            [required]="part.required ?? false" />

      <!-- file picker -->
      <section *ngIf="part.type === 'file'">
        <sabis-ngx-filepicker [uploader]="part.uploaderService!"
                              [files]="part.value"
                              [directoryPath]="part.fileDirectoryPath!"
                              (fileChanged)="onModelChange($event, part)"></sabis-ngx-filepicker>
      </section>
    </div>
  </div>
  <div modal-footer>
    <sabis-ngx-button *ngFor="let button of buttons" (click)="onActionButtonClick(button)">
      {{ button.name }}
    </sabis-ngx-button>
  </div>

</sabis-ngx-dialog>
